import { TOAST_TYPE } from "../../constants";
import { ADMIN_AUTH_ROUTES } from "../../constants/adminApiRoutes";
import { ADMIN_ROUTES } from "../../constants/appRoutes";
import { CUSTOMER_AUTH_ROUTES } from "../../constants/customerApiRoutes";
import { showToastMessage } from "../../utils";
import API from "../axios";

export const fpSendMail = async (
  apiResponse: CallableFunction,
  handleLoading: CallableFunction,
  data: any
) => {
  try {
    const response = await API.post(ADMIN_AUTH_ROUTES.ADMIN_FP_SENDMAIL, data);
    apiResponse(response);
    if (response.status === 200) {
      showToastMessage(TOAST_TYPE.SUCCESS, response.data.message);
    } else {
      showToastMessage(TOAST_TYPE.ERROR, response.data.message);
    }
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const fpReSendMail = async (
  handleApiResponse: CallableFunction,
  handleLoading: CallableFunction
) => {
  try {
    const response = await API.post(`${ADMIN_AUTH_ROUTES.ADMIN_FP_SENDMAIL}`);
    handleApiResponse(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const fpSetNewPassword = async (
  handleLoading: CallableFunction,
  redirect: CallableFunction,
  data: any
) => {
  try {
    const response = await API.post(
      location?.pathname?.startsWith("/admin")
        ? ADMIN_AUTH_ROUTES.ADMIN_FP_RESET_PASSWORD
        : CUSTOMER_AUTH_ROUTES.RESET_PASSWORD,
      data
    );
    if (response.status === 200) {
      showToastMessage(TOAST_TYPE.SUCCESS, response.data.message);
      redirect();
    } else {
      showToastMessage(TOAST_TYPE.ERROR, response.data.message);
    }
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const authChangePassword = async (
  handleLoading: CallableFunction,
  redirect: CallableFunction,
  data: any
) => {
  try {
    const response = await API.post(
      ADMIN_AUTH_ROUTES.ADMIN_CHANGE_PASSWORD,
      data
    );
    if (response.status === 200) {
      showToastMessage(TOAST_TYPE.SUCCESS, response.data.message);
      redirect(`${ADMIN_ROUTES.PROFILE}`);
    } else {
      showToastMessage(TOAST_TYPE.ERROR, response.data.message);
    }
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const updateAuthProfile = async (
  handleLoading: CallableFunction,
  callback: CallableFunction,
  data: any
) => {
  try {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value as string | Blob);
    });

    const response = await API.put(ADMIN_AUTH_ROUTES.ADMIN_PROFILE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) {
      showToastMessage(TOAST_TYPE.SUCCESS, response.data.message);
      callback();
    } else {
      showToastMessage(TOAST_TYPE.ERROR, response.data.message);
    }
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};
